export default __webpack_public_path__ + "static/media/placeholder_dummy2016-naeherin01-mobile-de.5c2d9bf8.png";